import parse from "html-react-parser";

export const parseHtml = (html: string, parseNewline = true) => {
  return parse(html.replace(/(?:\r\n|\r|\n)/g, parseNewline ? "<br />" : " "));
};
